import { render, staticRenderFns } from "./AddNewDocumentsActivies.vue?vue&type=template&id=6eb4451d&scoped=true&"
import script from "./AddNewDocumentsActivies.vue?vue&type=script&lang=js&"
export * from "./AddNewDocumentsActivies.vue?vue&type=script&lang=js&"
import style0 from "./AddNewDocumentsActivies.vue?vue&type=style&index=0&id=6eb4451d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb4451d",
  null
  
)

export default component.exports